module.exports = __webpack_public_path__ + "img/mail_logo.3455999e.svg";